import React from 'react';
import { Star, User } from 'lucide-react';
import { Card } from '../ui/card';
import { testimonials } from '../../mockData';

const TestimonialsSection = () => {
  return (
    <section id="testimonials" className="section-gray">
      <div className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-lg mb-6">Student Success Stories</h2>
          <p className="body-lg text-[var(--text-muted)]">
            Hear from students and parents who've achieved their goals with our coaching.
          </p>
        </div>
        <div className="grid-2 max-w-5xl mx-auto">
          {testimonials.map((testimonial) => (
            <Card key={testimonial.id} className="premium-card">
              <div className="rating-stars mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={`testimonial-star-${testimonial.id}-${i}`} className="w-5 h-5 fill-current" />
                ))}
              </div>
              <p className="body-md mb-6 italic">"{testimonial.text}"</p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center" style={{ background: 'var(--bg-light)' }}>
                  <User className="w-6 h-6" style={{ color: 'var(--accent-sky)' }} />
                </div>
                <div>
                  <p className="font-semibold" style={{ color: 'var(--primary-navy)' }}>{testimonial.name}</p>
                  <p className="text-sm text-[var(--text-muted)]">{testimonial.role}</p>
                  {testimonial.achievement && (
                    <p className="text-sm font-medium mt-1" style={{ color: 'var(--secondary-gold)' }}>
                      {testimonial.achievement}
                    </p>
                  )}
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
